import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Who We Are',
    path: '/about'
  }, {
    name: 'What We Do',
    path: '/services'
  }, {
    name: 'Contact Us',
    path: '/contact'
  }];
  return <header className="w-full bg-white shadow-sm" data-id="element-60">
      <nav className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-61">
        <Link to="/" className="flex items-center" data-id="element-62">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vtTMidWxEm18GMUDR2LR8M/TC_Lawyering_Logo.png" alt="The Concierge Lawyering Logo" className="h-12 md:h-16" data-id="element-63" />
        </Link>
        {/* Desktop Navigation */}
        <div className="hidden md:flex space-x-8" data-id="element-64">
          {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm uppercase tracking-wider font-medium transition-colors duration-300 ${location.pathname === link.path ? 'text-[#c8a951] border-b-2 border-[#c8a951]' : 'text-[#1a2542] hover:text-[#c8a951]'}`} data-id="element-65">
              {link.name}
            </Link>)}
        </div>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-[#1a2542] focus:outline-none" onClick={toggleMenu} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-66">
          {isMenuOpen ? <XIcon size={24} data-id="element-67" /> : <MenuIcon size={24} data-id="element-68" />}
        </button>
      </nav>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white py-4 px-4 shadow-lg" data-id="element-69">
          <div className="flex flex-col space-y-4" data-id="element-70">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm uppercase tracking-wider font-medium py-2 transition-colors duration-300 ${location.pathname === link.path ? 'text-[#c8a951] border-l-4 border-[#c8a951] pl-2' : 'text-[#1a2542] hover:text-[#c8a951] pl-2'}`} onClick={() => setIsMenuOpen(false)} data-id="element-71">
                {link.name}
              </Link>)}
          </div>
        </div>}
    </header>;
};
export default Navbar;